var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 18,
    height: 18,
    transform: "translate(60 171)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_31",
    "data-name": "Mask Group 31",
    transform: "translate(-60 -171)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(60 170.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M3.013,13.381a1.125,1.125,0,0,1,.323.9,12.341,12.341,0,0,1-.448,2.25,13.285,13.285,0,0,0,2.963-1,1.125,1.125,0,0,1,.8-.083A9.067,9.067,0,0,0,9,15.75c4.5,0,7.875-3.158,7.875-6.75S13.5,2.25,9,2.25,1.125,5.409,1.125,9A6.183,6.183,0,0,0,3.013,13.381Zm-.555,4.393q-.4.079-.8.145a.292.292,0,0,1-.307-.407q.15-.353.274-.717l0-.011a11.751,11.751,0,0,0,.589-2.609A7.308,7.308,0,0,1,0,9C0,4.651,4.03,1.125,9,1.125S18,4.651,18,9s-4.03,7.875-9,7.875a10.193,10.193,0,0,1-2.64-.344A15.378,15.378,0,0,1,2.458,17.774Z",
    fill: "#9babc5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.358eaf77c45cdaeca169638e403017ae.svg";
export { ForwardRef as ReactComponent };